export default (error, vm) => {

    let errorCode = error && typeof error.error_code !== 'undefined' ? error.error_code : undefined;
    //没有下沉模块的error判断
    if (typeof errorCode === 'undefined') {
        if (!error) {
            return '';
        }
        if (error.errorMsg) {
            return error.errorMsg;
        }
        if (error.status === 403) {
            return '';
        }
        if (vm && vm.$t) {
            if (error.status === false) {
                return vm.$t('commonStatusCode.4015');
            }
            const errorCode = vm.$te(`commonStatusCode.${error.status}`) ? error.status : 400;
            return vm.$t(`commonStatusCode.${errorCode}`);
        }
        return error;
    }

    //已下沉的模块
    if (vm && vm.$t) {
        if (!vm.$te(`commonStatusCode.${errorCode}`)) {
            errorCode = 400;
        }
        return vm.$t(`commonStatusCode.${errorCode}`);
    }
    return errorCode;
};
